'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var OFFSET_HEIGHT = exports.OFFSET_HEIGHT = 64;
var OFFSET_HEIGHT_EXTENDED = exports.OFFSET_HEIGHT_EXTENDED = 76;

var MOBILE_OFFSET_HEIGHT = exports.MOBILE_OFFSET_HEIGHT = 104;
var MOBILE_OFFSET_HEIGHT_EXTENDED = exports.MOBILE_OFFSET_HEIGHT_EXTENDED = 116;

var BASE_WIDGET_HEIGHT = exports.BASE_WIDGET_HEIGHT = 530;
var SMALLEST_WIDGET_HEIGHT = exports.SMALLEST_WIDGET_HEIGHT = 247;

var BASE_WIDGET_WIDTH = exports.BASE_WIDGET_WIDTH = 376;

var CLOSE_BUTTON_AND_SPACING = exports.CLOSE_BUTTON_AND_SPACING = 16 + 60 + 16;
var SPACING_ABOVE_WIDGET = exports.SPACING_ABOVE_WIDGET = 24 + 20;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/widget-dimensions/constants/dimensions.js
// module id = 207
// module chunks = 2 3